import React from 'react';

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from 'reactstrap';
import Types from "../../../../../constants/Types";
import API from "@beardeddevops/react.api";

const {UniversalModal} = Framework.Elements;
const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'AmmoReady Inventory',
		url: '/skus/ammoready',
		icon: 'folder',
	}
];

export default class AmmoReady extends Framework.Components.View {

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button data-id="add-sku" onClick={async () => {
						try {
							this.setState({loading: true})
							const model = new API.BuildClass(Types.Ammoready_Inventory._name, 'GET_SYNC');

							await model.submit(null, 'GET_SYNC')
						} catch (e) {
							console.error(e);
						} finally {
							await this.refreshPage();
							this.setState({loading: false})
						}
					}} size={"sm"} color="warning" style={{ borderRadius: '6px' }}>
						<i className="fa fa-refresh"/>&nbsp;&nbsp;Sync AmmoReady Inventory
					</Button>
					<Button data-id="add-sku" onClick={this.toggle('modalAdd')} size={"sm"} className="primary-button">
						<i className="fa fa-list-alt"/>&nbsp;&nbsp;Add to POS Inventory
					</Button>
				</Framework.Components.PageBar>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Collections.AmmoReadyInventory
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>
				</Framework.Errors.General>

				<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>

				<UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					locations={this.props.locations}
					name={"New POS Inventory"}
					object={Objects.Sku}
					history={this.props.history}
					toggle={this.state['modalAdd']}
					reportClose={this.reportClose('modalAdd')}
					afterSave={this.handleAfterSave}
					size={'lg'}
					objectProps={{requireAmmoready: true}}
					project={'pos'}
				/>

			</div>
		);
	}
}
